import { AxiosRequestConfig } from 'axios'

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '/api'

/** 定义axios基础配置 */
export const axiosBaseOptions: AxiosRequestConfig = {
  baseURL: apiBaseUrl, // 线上未注入环境变量时，默认走 nginx 的 /api 反向代理
  timeout: 10000,
}
